import apiService from './api';

export interface Company {
  id: string;
  name: string;
  email: string;
  phone: string;
}

export interface CreateCompanyPayload {
  name: string;
  email: string;
  phone: string;
}

export interface UpdateCompanyPayload {
  name?: string;
  email?: string;
  phone?: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

class CompanyService {
  async listCompanies(params?: { search?: string; page?: number; limit?: number }): Promise<PaginatedResponse<Company>> {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());

    const queryString = queryParams.toString();
    const endpoint = `/admin/companies${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiService.get<PaginatedResponse<Company>>(endpoint);
    if (response.error) {
      throw new Error(response.error);
    }
    return response.data!;
  }

  async createCompany(payload: CreateCompanyPayload): Promise<Company> {
    const response = await apiService.post<Company>('/admin/companies', payload);
    if (response.error) {
      throw new Error(response.error);
    }
    return response.data!;
  }

  async getCompany(id: string): Promise<Company> {
    const response = await apiService.get<Company>(`/admin/companies/${id}`);
    if (response.error) {
      throw new Error(response.error);
    }
    return response.data!;
  }

  async updateCompany(id: string, payload: UpdateCompanyPayload): Promise<Company> {
    const response = await apiService.put<Company>(`/admin/companies/${id}`, payload);
    if (response.error) {
      throw new Error(response.error);
    }
    return response.data!;
  }

  async deleteCompany(id: string): Promise<void> {
    const response = await apiService.delete<void>(`/admin/companies/${id}`);
    if (response.error) {
      throw new Error(response.error);
    }
  }
}

const companyService = new CompanyService();
export default companyService;
